export class FetchRelaysAction {
  static readonly type = '[Relays] Fetch Relays';
}
